import { render, staticRenderFns } from "./digital-currency-7-account-balance-number-with-icon.vue?vue&type=template&id=9f998d90&"
import script from "./digital-currency-7-account-balance-number-with-icon.vue?vue&type=script&lang=ts&"
export * from "./digital-currency-7-account-balance-number-with-icon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
installComponents(component, {VAvatar})
